module.exports = __webpack_public_path__ + "img/616.Micro.a9178445.svg";